import React from 'react';
import { InfoIcon, Tooltip } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var MAX_WIDTH_TOOLTIP = '200';
export var IconWithTooltip = function IconWithTooltip(_ref) {
  var containerRef = _ref.containerRef,
    message = _ref.message;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('tooltip'),
    "data-t-id": "components-IconWithTooltip"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    containerRef: containerRef,
    maxWidth: MAX_WIDTH_TOOLTIP,
    message: message,
    position: "bottom"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    fill: "white",
    size: 20,
    "data-t-id": "components-IconWithTooltip"
  })));
};